import React from 'react';
import styled from 'styled-components/macro';
import { DeviceSize } from '../../components/basic/DeviceSize';

type Props = {
  columnsDesktop?: number;
  columnsTablet?: number;
  columnsMobile?: number;
  gap?: React.CSSProperties['gap'];
};

type Test = Pick<Props, 'columnsDesktop' | 'columnsTablet' | 'columnsMobile' | 'gap'>;

const Container = styled.div<Test>`
  display: grid;
  gap: ${(props) => props.gap};
  grid-template-columns: repeat(${(props) => props.columnsDesktop}, 1fr);
  align-items: start; // Don't stretch cards to full height

  @media ${DeviceSize.desktopM} {
    grid-template-columns: repeat(${(props) => props.columnsTablet}, 1fr);
    align-items: initial; // On tablet, it's neater to stretch cards to the same size
  }

  @media ${DeviceSize.desktopS} {
    grid-template-columns: 1fr;
  }
`;

const Grid: React.FC<Props> = ({
  children,
  columnsDesktop = 3,
  columnsTablet = 2,
  columnsMobile = 1,
  gap = '20px',
}) => {
  return (
    <Container columnsDesktop={columnsDesktop} columnsTablet={columnsTablet} columnsMobile={columnsMobile} gap={gap}>
      {children}
    </Container>
  );
};

export default Grid;
